export const environment = {
  production: false,
  msalConfig: {
    auth: {
      clientId: 'a4cf5215-334d-4997-89e4-1e87e3d5f154',
      authority: 'https://login.microsoftonline.com/a0d2eaf1-c173-4688-905f-4b704f3d0eca',
      redirectUri: 'https://dev.evoluciona.vippinn.net.ar/auth/callback'
    }
  },
  apiConfig: {
    scopes: ['openid', 'profile', 'email', 'User.Read'],
    uri: 'https://graph.microsoft.com/v1.0/me'
  },
  accountingApi: {
    baseUrl: 'https://dev.evoluciona.vippinn.net.ar',
    endpoints: {
      salesByAnalytic: '/api/',
      projects: '/api/projects',
      projectByCode: '/api/project',
      projectStatus: '/api/system/project/status',
      projectTypes: '/api/system/project/types',
      regions: '/api/system/regions',
      companies: '/api/system/companies',
      businessUnits: '/api/system/business_units',
      countries: '/api/system/countries',
      productTypes: '/api/system/product_types',
      responsiblesRoles: '/api/system/responsibles_roles',
      servicesTypes: '/api/system/services_types',
      invoiceStates: '/api/system/invoice_states',
      invoices: '/api/invoices'
    }
  }
};
